import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Modal, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import { moduleList } from "../../../utils/api";
import { useTranslation } from "react-i18next";
import { general_module_type } from "../../../utils/dictionary";
function CultureActivities() {
  const { t } = useTranslation();
  const cultureContent = t("home.anchorPoint5", { returnObjects: true });
  const language = localStorage.getItem("i18nextLng"); // 语言
  const history = useHistory();
  const [moduleCode, setModuleCode] = useState(
    language === "zh" ? "HL_culturalActivities" : "HL_culturalActivities_en"
  );
  const [allName, setAllName] = useState(language === "zh" ? "全部" : "All");

  const [moduleType, setModuleType] = useState("");
  const [classification, setClassification] = useState("");
  const [dataList, setDataList] = useState([]);
  const [activeInfo, setActiveInfo] = useState(null);
  useEffect(async () => {
    getPages();
  }, [moduleType, classification]);
  const getPages = async () => {
    let opt = {
      websiteName: "惠联官网",
      websiteCode: "HUILIAN",
      moduleCode: moduleCode,
      moduleType,
      codeBak: classification,
      pageIndex: 0,
      pageSize: 20,
    };
    let data = await moduleList(opt);
    let lists = [];
    for (let i = 0; i < data.data.pageContent.length; i++) {
      let obj = JSON.parse(data.data.pageContent[i].moduleValue);
      lists.push({
        ...data.data.pageContent[i],
        ...obj,
      });
    }
    setDataList(lists);
  };
  const handleCancel = () => {
    setActiveInfo(null);
  };
  return (
    <div className="cultureActivities_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{cultureContent}</div>
        </div>
      </div>
      <div className="cultureActivities_con">
        <div className="cultureActivities_top">
          <div className="top_list">
            <div
              className={moduleType === "" ? "top_list_active" : ""}
              onClick={() => {
                setModuleType("");
              }}
            >
              {allName}
            </div>
            {general_module_type[moduleCode].map((item, index) => {
              return (
                <div
                  className={moduleType === item ? "top_list_active" : ""}
                  key={index}
                  onClick={() => {
                    setModuleType(item);
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </div>
        <div className="cultureActivities_Bottom">
          {dataList.map((item, index) => {
            return (
              <div
                className={`bottom_con ${index === 0 ? "bottom_con0" : ""}`}
                key={index}
                onClick={() => {
                  console.log({
                    ...item,
                    moduleValue: JSON.stringify(item.moduleValue),
                  });

                  setActiveInfo({
                    ...item,
                    moduleValue: JSON.stringify(item.moduleValue),
                  });
                }}
              >
                <div className={`bottom_top_img ${index === 0 ? "bottom_top_img0" : ""}`}>
                  <img src={item.imgs} alt="" />
                </div>
                <div className="bottom_bottom">
                  <div className="bottom_tit">{item.subtitle}</div>
                  <Tooltip title={item.title}>
                    <div className="bottom_moduleType">{item.title}</div>
                  </Tooltip>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        visible={activeInfo}
        footer={null}
        width={1000}
        onCancel={() => handleCancel()}
      >
        <div className="casesList_con">
          <img style={{ width: "100%" }} src={activeInfo?.imgs} />
          <div className="casesList_li">
            <h3 className="casesList_tit">{activeInfo?.title}</h3>
            <div className="casesList_label_con">
              <div className="casesList_label">
                {activeInfo?.subtitle}
              </div>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: activeInfo?.context }}></div>
        </div>
      </Modal>
    </div>
  );
}

export default CultureActivities;
